import React from "react";

const CryptoDepositIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="#DAF2EA"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.00012207" width="32" height="32" rx="16" fill="#DAF2EA" />
      <path
        d="M18.1779 12.8H22.0889C22.2762 12.7981 22.4565 12.8709 22.5899 13.0023C22.7234 13.1337 22.799 13.3129 22.8 13.5002V23.2998C22.799 23.4871 22.7234 23.6662 22.5899 23.7976C22.4565 23.929 22.2762 24.0018 22.0889 24H10.711C10.5238 24.0018 10.3435 23.929 10.21 23.7976C10.0766 23.6662 10.001 23.4871 10 23.2998V13.5002C10.001 13.3129 10.0766 13.1337 10.21 13.0023C10.3435 12.8709 10.5238 12.7981 10.711 12.8H14.6221"
        stroke="#022B1D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.4 8.00012V16.9601"
        stroke="#022B1D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.352 15.0402L16.4 16.9602L18.448 15.0402"
        stroke="#022B1D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CryptoDepositIcon;
